import React from 'react';
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface CustomFontUploadProps {
  customFontFile: File | null;
  onFileChange: (file: File | null) => void;
  uploading: boolean;
  currentFontUrl?: string | null;
}

export function CustomFontUpload({ 
  customFontFile, 
  onFileChange, 
  uploading, 
  currentFontUrl 
}: CustomFontUploadProps) {
  return (
    <div className="ml-6 space-y-4">
      <div>
        <Label htmlFor="font-upload">Upload Font File (.woff2 or .ttf)</Label>
        <div className="flex items-center gap-2 mt-1">
          <Input
            id="font-upload"
            type="file"
            accept=".woff2,.ttf"
            onChange={(e) => onFileChange(e.target.files?.[0] || null)}
            className="flex-1"
          />
          {uploading && <div className="text-sm text-muted-foreground">Uploading...</div>}
        </div>
      </div>
      
      {currentFontUrl && (
        <div className="text-sm text-muted-foreground">
          Current custom font: {currentFontUrl.split('/').pop()}
        </div>
      )}
    </div>
  );
}